import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ReportDialogs } from '../../constants/Dialogs';
import { withId } from '../Common/Decorators';

import DetailView from '../Common/DetailView';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import ReportScheduleDialog from './ReportScheduleDialog';
import ReportScheduleHistory from './ReportScheduleHistory';

import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DialogActions from '../../actions/DialogActionCreator';
import ReportActions from '../../actions/ReportActionCreator';

import ReportScheduleStore from '../../stores/ReportScheduleStore';
import buildContextMenu from '../Common/BuildContextMenu';
import ROLES from '../../constants/Roles';

const formatSchedule = (schedule) => {
    if (!schedule) { return null; }
    if (schedule instanceof Date) { return schedule; }

    const time = schedule.split(':');
    const date = new Date();
    date.setHours(time[0], time[1]);

    return date;
}

class ReportSchedule extends Component {

    componentWillMount() {
        ReportActions.getSchedule(this.props.id);
    }

    render() {
        return (
            <DetailView
                actions={buildContextMenu(this.getMenuItems(), this.context.auth)}
                backButton
            >
                <div className="cent-cards">
                    <Card className="cent-card" style={{width: '100%'}}>
                        <CardHeader title="Scheduled report" />
                        <CardText className="cent-card-text">
                            <div className="cent-flex-row">
                                <div className="cent-col-2">
                                    <ul className="cent-list-plain">
                                        <li><em>Name: </em>{this.state.details.name}</li>
                                        <li><em>Report: </em>
                                            <Link to={`/dashboard/report/${this.state.details.reportId}`}>{this.state.details.reportName}</Link>
                                        </li>
                                        <li><em>Time: </em>{this.state.details.schedule}</li>
                                        <li><em>Repeat Interval: </em>1 {this.state.details.repeatInterval}</li>
                                    </ul>
                                </div>
                                <div className="cent-col-2">
                                    <ul className="cent-list-plain">
                                        <li><em>Recipients: </em>
                                            {!!this.state.details.recipients && this.state.details.recipients.join(', ')}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </CardText>
                    </Card>
                    {!!this.state.details.taskId && (
                        <ReportScheduleHistory taskId={Number(this.state.details.taskId)}/>
                    )}
                </div>
                <ReportScheduleDialog/>
            </DetailView>
        );
    }

    getMenuItems() {
        return [
            {
                action: () => DialogActions.open(ReportDialogs.SCHEDULE_EDIT, {...this.state.details, schedule: formatSchedule(this.state.details.schedule)}),
                icon: <EditIcon/>,
                label: 'Edit schedule',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
        ];
    };
}

ReportSchedule.getStores = () => ([ReportScheduleStore]);
ReportSchedule.calculateState = (prevState, {id}) => ({
    details: ReportScheduleStore.getById(id) || {}
});
ReportSchedule.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(Container.create(ReportSchedule, {withProps: true}));
